<template>
  <div class="">
    <div>
      <!-- Admins & Roles Content -->
      <div>
        <!-- Statistics Cards -->
        <b-row>
          <b-col cols="12" md="6">
            <b-card>
              <div class="d-flex align-items-center">
                <div
                  style="
                    background: #eff6ff;
                    width: fit-content;
                    width: 35px;
                    height: 35px;
                    border-radius: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <feather-icon
                    icon="UsersIcon"
                    size="20"
                    class="align-middle text-primary"
                  />
                </div>
                <div class="d-flex flex-column ml-1">
                  <span class="text-muted text-nowrap">Admin Users</span>
                  <span
                    class="text-body"
                    style="font-size: 20px; font-weight: 900"
                    >{{ totalAdmin }}</span
                  >
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6">
            <b-card>
              <div class="d-flex align-items-center">
                <div
                  style="
                    background: #dcfce7;
                    width: fit-content;
                    width: 35px;
                    height: 35px;
                    border-radius: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <feather-icon
                    icon="UserCheckIcon"
                    size="20"
                    class="align-middle text-success"
                  />
                </div>
                <div class="d-flex flex-column ml-1">
                  <span class="text-muted text-nowrap">Role Templates</span>
                  <span
                    class="text-body"
                    style="font-size: 20px; font-weight: 900"
                    >{{ totalRole }}</span
                  >
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <!-- TAB USERS -->
        <AdminList v-if="$store.state.app.activeMenuSetting === 1" />
        <!-- TAB ROLES -->
        <!-- <AdminPermissionList v-if="$store.state.app.activeMenuSetting === 2" /> -->
        <!-- TAB SETTINGS -->
        <RoleSetting v-if="$store.state.app.activeMenuSetting === 3" />
        <AuditLogs v-if="$store.state.app.activeMenuSetting === 4" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BIcon,
  BRow,
  BButton,
  BFormInput,
  BTable,
} from "bootstrap-vue";
import AdminList from "../roles-permissions/user-list/AdminList.vue";
import useToastHandler from "@/services/toastHandler";
import { mapActions, mapState } from "vuex";
import RoleSetting from "../roles-permissions/roles-permissions-view/RoleSetting.vue";
import AdminPermissionList from "../roles-permissions/user-list/AdminPermissionList.vue";
import AuditLogs from "../roles-permissions/audit-logs";

export default {
  components: {
    BIcon,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    AdminList,
    BTable,
    RoleSetting,
    AdminPermissionList,
    AuditLogs,
  },
  data() {
    return {
    };
  },
  async mounted() {
    await Promise.all([this.getTotalAdmin(), this.getTotalRole()]);
  },
  computed: {
    ...mapState("user/statistic", ["totalAdmin", "totalRole"]),
  },
  methods: {
    ...mapActions({
      getRoleList: "user/admin/getRoleList",
      getTotalAdmin: "user/statistic/getTotalAdmin",
      getTotalRole: "user/statistic/getTotalRole",
    }),
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
    };
  },
};
</script>

<style scoped>
.main-wrapper {
  min-height: calc(100vh - 150px);
}

.sidebar-col {
  padding: 0;
  position: fixed;
  top: 110px;
  left: 0;
  width: 16.666667%;
  height: calc(100vh - 110px);
  z-index: 1000;
}

.sidebar {
  height: 100%;
  border-right: 1px solid #e5e7eb;
  overflow-y: auto;
}

.main-content-col {
  padding: 0;
  margin-left: 16.666667%;
  width: calc(100% - 16.666667%);
}

.main-content {
  height: calc(100vh - 130px);
  overflow-y: auto;
}

@media (max-width: 768px) {
  .sidebar-col {
    position: relative;
    top: auto;
    left: auto;
    width: 100%;
    height: auto;
  }

  .main-content-col {
    margin-left: 0;
    width: 100%;
  }

  .main-content {
    height: auto;
    overflow-y: visible;
  }
}

.stat-card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.section-card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.table th {
  font-weight: 600;
  color: #6b7280;
  font-size: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.table td {
  vertical-align: middle;
  font-size: 14px;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.fw-medium {
  font-weight: 500;
}

.badge {
  font-size: 12px;
  padding: 4px 8px;
}

.table-footer {
  background-color: #f8f9fa;
}

@media (max-width: 768px) {
  .sidebar-col {
    display: none;
  }

  .main-content-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.nav-active {
  background: #eff6ff;
  color: #2979ff;
}
.link {
  padding: 10px;
  padding-left: 25px;
  gap: 10px;
  display: flex;
  align-items: center;
}
.permission-changed {
  position: relative;
}

.permission-changed::before {
  content: "";
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border: 2px solid #007bff;
  border-radius: 4px;
  pointer-events: none;
}
</style>
